import { del, get, post, put } from "../../services/ApiRouting";

// Function to fetch all services
export async function getAllServices(page = 1) {
  try {
    const response = await get(`${API_URL}/crud/services?page=${page}`);
    return response;
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to create a new service
export async function createService(serviceData) {
  try {
    const response = await post(`${API_URL}/crud/services`, serviceData);
    return response;
  } catch (error) {
    console.error("Error creating service:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to fetch a single service by ID
export async function getServiceById(serviceId) {
  try {
    const response = await axios.get(`${API_URL}/crud/services/${serviceId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching service with ID ${serviceId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to update an existing service
export async function updateService(serviceId, serviceData) {
  try {
    const response = await put(
      `${API_URL}/crud/services/${serviceId}`,
      serviceData
    );
    return response;
  } catch (error) {
    console.error(`Error updating service with ID ${serviceId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}

// Function to delete a service
export async function deleteService(serviceId) {
  try {
    const response = await del(`${API_URL}/crud/services/${serviceId}`);
    return response;
  } catch (error) {
    console.error(`Error deleting service with ID ${serviceId}:`, error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
